import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';
import { get } from 'lodash';

import { fetchTicketList, saveTicketsSelection, clearTicketsSelection, createTicketReserve } from '../../eventActions';
import { openLoginModal } from 'Parts/ui/uiActions';
import { fetchTeam } from '../../../../../team/teamActions';


import ChooseTicketsForm from './ChooseTicketsForm';

const mapStateToProps = state => ({
  campaign: get(state, 'campaign.campaign'),
  team: get(state, 'team.team'),
  locale: get(state, 'session.language'),
  tickets: get(state, 'Event.tickets'),
  userTypeId: get(state, 'session.userTypeId'),
  reserve: get(state, 'Event.reserve'),
  eventTicketLimit: get(state, 'Event.event.settings.ticket.limit', null)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchTicketList,
  saveTicketsSelection,
  clearTicketsSelection,
  fetchTeam,
  openLoginModal,
  createTicketReserve
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  Form.create()
)(ChooseTicketsForm);
